<div class="d-flex flex-column h-100 overflow-hidden">

  @if (alertService.alert()) {
    <app-alert-message [message]="alertService.alert()!.message"
                       [type]="alertService.alert()!.type"></app-alert-message>
  }

  <app-confirm-dialog></app-confirm-dialog>

  <app-header></app-header>
  <main class="flex-grow-1 overflow-auto p-2 p-md-3" style="min-height: 0;">
    <div class="container-fluid position-relative d-flex flex-column justify-content-center px-1 px-sm-2" style="min-height: 100%">
      <app-loader [isLoading]="loadingService.isLoading()"></app-loader>
      <router-outlet></router-outlet>
    </div>
  </main>

  <app-footer></app-footer>

</div>
